module.exports = __webpack_public_path__ + "static/hero-flamingo-bd442a22810603f39a024454c31c71ac.jpg";